import * as _ from 'lodash';
import { IContact } from '@nkr/models/index';
import { Button, Label } from 'react-bootstrap';

interface IProps {
    data: IContact,
    edit: boolean,
    delete: boolean,
    onEdit: (id: number) => void,
    onConfirmDelete: (id: number) => void
}

const ContactRow = (props: IProps) => {
    const getRoles = () => {
        let { positionText, positions } = props.data;

        if (positionText != '') {
            return props.data.positionText
        }

        if (positions.length > 0) {
            return _.join(positions.map(x => x.description), ', ');
        }

        return <Label style={{ fontSize: '100%' }}>not specified</Label>
    };

    let { id, fullName, email } = props.data;
    let disabled = props.edit || props.delete;

    return (
        <tr style={{ backgroundColor: props.edit ? 'yellow' : null }}>
            <td>{getRoles()}</td>
            <td>{fullName}</td>
            <td>{email}</td>
            <td>
                <Button bsSize='sm' style={{ paddingTop: 2, paddingBottom: 2 }} disabled={disabled} onClick={() => props.onEdit(id)}>Edit</Button>{' '}
                <Button bsSize='sm' style={{ paddingTop: 2, paddingBottom: 2 }} disabled={disabled} onClick={() => props.onConfirmDelete(id)}>Delete</Button>
            </td>
        </tr>
    );
}

export default ContactRow;